
import React from "react";
import "./About.css";
import aboutimg from "../../img/about.jfif";



const About= () => {
   return (
<>  
<div className="about" id="about">
  <hr></hr>
<section className= "main-hero-container">
<div className="a-heading">
              <h1 className="display-2">
              Get Quality education <br /> 
              </h1>
              </div>
            

 <div className="a-subheading"><p>
       Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem
        praesentium nostrum doloribus, aut nobis iusto. Omnis quam rem aliquid, <br></br>
        molestias blanditiis fuga quisquam 
      voluptas dignissimos animi voluptate velit eos distinctio.
       </p>
     </div>

     <div className="a-overflow">
<div className="upper">
     15K &nbsp;&nbsp;  150k&nbsp;&nbsp;&nbsp; 87 &nbsp;&nbsp;&nbsp;15
     </div>
     <div className="lower">
     &nbsp;&nbsp;Happy customers &nbsp;&nbsp;Monthly visitors &nbsp;&nbsp;Partners  
     &nbsp;&nbsp;Countries service
     </div>

     </div>
     </section>
     </div>
    
      </>
  
  );
};

export default About;